<template>
  <div class="nx-list-page">
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      :before-open="beforeOpen"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-upload
          class="own-vehicle-upload"
          action="#"
          accept=".xls,.xlsx"
          :show-file-list="false"
          :http-request="handleImport"
        >
          <el-button type="primary" size="small" plain icon="el-icon-upload2" :loading="importLoading">导入</el-button>
        </el-upload>
        <el-button
          class="own-vehicle-template-btn"
          type="primary"
          size="small"
          plain
          icon="el-icon-document"
          :loading="templateLoading"
          @click="handleDownloadTemplate"
        >
          模板下载
        </el-button>
        <el-button type="primary" size="small" plain icon="el-icon-download" :loading="exportLoading" @click="handleExport">导出</el-button>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import crudMixins from '@/mixins/crud-mixins';
import { getList, add, update, remove, getDetail, exportExcel, importExcel, downloadTemplate } from './api';
import { rulesInput } from '@/basic-common/util/common';
import { downloadXls } from '@/util/util';

export default {
  name: 'finance-own-vehicle',
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList, add, update, remove, getDetail },
      exportLoading: false,
      importLoading: false,
      templateLoading: false,
      option: {
        ...this.$store.state.publicOption,
        labelWidth: 120,
        dialogWidth: 640,
        column: [
          {
            label: '车牌号',
            prop: 'vehicleNo',
            search: true,
            minWidth: 120,
            maxlength: 20,
            rules: rulesInput(1),
          },
          {
            label: '有效开始',
            prop: 'beginTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            width: 170,
          },
          {
            label: '有效结束',
            prop: 'endTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            width: 170,
          },
          {
            label: '状态',
            prop: 'status',
            type: 'select',
            search: true,
            width: 90,
            dicData: [
              { label: '停用', value: 0 },
              { label: '有效', value: 1 },
            ],
            value: 1,
            rules: rulesInput(2),
          },
          {
            label: '备注',
            prop: 'remark',
            type: 'textarea',
            maxlength: 200,
            span: 24,
            minRows: 2,
            hide: true,
          },
          {
            label: '创建人',
            prop: 'createUser',
            addDisplay: false,
            editDisplay: false,
            width: 100,
          },
          {
            label: '创建时间',
            prop: 'createTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            width: 170,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '更新人',
            prop: 'updateUser',
            addDisplay: false,
            editDisplay: false,
            hide: true,
          },
          {
            label: '更新时间',
            prop: 'updateTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            width: 170,
            addDisplay: false,
            editDisplay: false,
          },
        ],
      },
    };
  },
  methods: {
    async handleDownloadTemplate() {
      this.templateLoading = true;
      try {
        const res = await downloadTemplate();
        downloadXls(res.data, '自有车辆导入模板.xlsx');
      } finally {
        this.templateLoading = false;
      }
    },
    async handleExport() {
      if ((this.page.total || 0) < 1) {
        this.$message.warning('无数据可导出');
        return;
      }
      this.exportLoading = true;
      try {
        const params = this.formatParams(Object.assign({}, this.query));
        const res = await exportExcel(params);
        downloadXls(res.data, `自有车辆_${Date.now()}.xlsx`);
        if (this.page.total > 10000) {
          this.$message.warning(`仅导出前 10000 条，共 ${this.page.total} 条`);
        } else {
          this.$message.success('导出成功');
        }
      } finally {
        this.exportLoading = false;
      }
    },
    async handleImport({ file }) {
      if (!file) {
        return;
      }
      const fileName = file.name || '';
      if (!/\.(xls|xlsx)$/i.test(fileName)) {
        this.$message.warning('仅支持 .xls/.xlsx 文件');
        return;
      }
      const formData = new FormData();
      formData.append('file', file);
      this.importLoading = true;
      try {
        const res = await importExcel(formData);
        if (res && res.data && res.data.success === false) {
          this.$message.error(res.data.msg || '导入失败');
          return;
        }
        const msg = res && res.data && res.data.msg ? res.data.msg : '导入成功';
        this.$message.success(msg);
        this.refreshChange();
      } finally {
        this.importLoading = false;
      }
    },
    beforeOpen(done, type) {
      if (type === 'add') {
        this.form.status = this.form.status != null ? this.form.status : 1;
        done();
        return;
      }
      if (['edit', 'view'].includes(type) && this.apiConfig.getDetail) {
        this.apiConfig.getDetail(this.form.id).then((res) => {
          this.form = res.data.data || res.data;
          done();
        });
        return;
      }
      done();
    },
  },
};
</script>
<style scoped lang="scss">
.own-vehicle-upload {
  display: inline-block;
  margin-right: 8px;
}

.own-vehicle-template-btn {
  margin-right: 8px;
}
</style>
